import { AssetState, ScanEvent, ScanEventType } from "./AssetScanTypes";

/**
 * Replays an asset's events in time order. The history decides, not the newest write: a late
 * entry with an earlier time then lands where it belongs instead of overwriting newer facts.
 */
export function recomputeAssetState(events: ScanEvent[], types: ScanEventType[]): AssetState {
  const typeByKey = new Map(types.map(type => [type.key, type]));
  const ordered = events
    .map((event, index) => ({ event, index }))
    .sort((a, b) => a.event.time.localeCompare(b.event.time) || a.index - b.index);

  const state: AssetState = {};
  for (const { event } of ordered) {
    state.lastEventAt = event.time;
    state.lastEventTypeKey = event.eventTypeKey;
    const type = typeByKey.get(event.eventTypeKey);
    if (!type) continue;

    if (type.changesLocation && event.lat !== undefined && event.lon !== undefined) {
      state.lat = event.lat;
      state.lon = event.lon;
    }
    if (type.customerEffect === "set" && event.customerId) {
      if (state.customerId !== event.customerId) state.customerSince = event.time;
      state.customerId = event.customerId;
    } else if (type.customerEffect === "release") {
      delete state.customerId;
      delete state.customerSince;
    }
    if (type.countsAsService) state.lastServiceAt = event.time;
  }
  return state;
}
